import { LicenseType } from '@ebalance/proto/bfftypes/v1/license_type_pb'

/** 札の発注主体 (= 札発行元の業務区分)。 通常の札・ブロック・時間前の表示行で共通。 */
export type BidIssuerType =
  | 'generation' // 発電
  | 'retail' // 小売
  | 'dr' // デマンドレスポンス
  | 'selfwheeling' // 自己託送
  | 'unknown' // 発注主体区分が空欄の取り込んだ札 (#10084)

/**
 * 発注主体区分 (`LicenseType`) を札の発注主体に写す。 空欄 (UNSPECIFIED) と、 札の発注主体に
 * 無い区分 (送配電・未知の値) は発電などに寄せず 'unknown' にする (#10084)。
 */
export const bidIssuerTypeOf = (licenseType: LicenseType): BidIssuerType => {
  switch (licenseType) {
    case LicenseType.GENERATION:
      return 'generation'
    case LicenseType.RETAIL:
      return 'retail'
    case LicenseType.DR:
      return 'dr'
    case LicenseType.SELF_WHEELING:
      return 'selfwheeling'
    default:
      return 'unknown'
  }
}

/** 発注主体区分が空欄の取り込んだ札の区分か。 3 画面 (通常・ブロック・時間前) で同じ判定を使う。 */
export const isUnknownIssuerLicenseType = (licenseType: LicenseType): boolean =>
  bidIssuerTypeOf(licenseType) === 'unknown'
